export default __webpack_public_path__ + "static/media/11-54.0d191cd2.png";